import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { createStyles, rem } from '@mantine/styles';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

function getVariantStyles(_ref) {
  var variant = _ref.variant,
      color = _ref.color,
      theme = _ref.theme;

  if (variant === "filled") {
    var colors = theme.fn.variant({
      variant: "filled",
      color
    });
    return {
      backgroundColor: colors.background,
      color: theme.white
    };
  }

  if (variant === "outline") {
    var _colors = theme.fn.variant({
      variant: "outline",
      color
    });

    return {
      color: _colors.color,
      borderColor: _colors.border,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white
    };
  }

  if (variant === "light") {
    var _colors2 = theme.fn.variant({
      variant: "light",
      color
    });

    return {
      backgroundColor: _colors2.background,
      color: _colors2.color
    };
  }

  return null;
}

var useStyles = createStyles(function (theme, _ref2, _ref3) {
  var radius = _ref2.radius,
      color = _ref2.color;
  var variant = _ref3.variant;
  return {
    root: __spreadValues(__spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
      position: "relative",
      overflow: "hidden",
      paddingTop: theme.spacing.sm,
      paddingBottom: theme.spacing.sm,
      paddingLeft: theme.spacing.md,
      paddingRight: theme.spacing.sm,
      borderRadius: theme.fn.radius(radius),
      border: "".concat(rem(1), " solid transparent")
    }), getVariantStyles({
      variant,
      color,
      theme
    })),
    wrapper: {
      display: "flex"
    },
    body: {
      flex: 1
    },
    title: {
      boxSizing: "border-box",
      margin: 0,
      marginBottom: theme.spacing.xs,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      lineHeight: theme.lineHeight,
      fontSize: theme.fontSizes.sm,
      fontWeight: 700,
      "&[data-with-close-button]": {
        paddingRight: theme.spacing.md
      }
    },
    label: {
      display: "block",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    icon: {
      lineHeight: 1,
      width: rem(20),
      height: rem(20),
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      marginRight: theme.spacing.md,
      marginTop: 1
    },
    message: __spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
      lineHeight: theme.lineHeight,
      textOverflow: "ellipsis",
      overflow: "hidden",
      fontSize: theme.fontSizes.sm,
      color: variant === "filled" ? theme.white : theme.colorScheme === "dark" ? variant === "light" ? theme.white : theme.colors.dark[0] : theme.black
    }),
    closeButton: {
      width: rem(10),
      height: rem(10)
    }
  };
});
export default useStyles;